// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdCat_importCsvCard__i7Xhe","addProdCatBtnContainer":"AddProdCat_addProdCatBtnContainer__O8foc"};